module.exports = require("/home/circleci/hbk/src/assets/jss/material-kit-react")